/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Camera_Attach_TitleInputs */

const vi_camera_attach_title = /** @type {(inputs: Camera_Attach_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gắn camera có sẵn`)
};

/**

* @param {Camera_Attach_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const camera_attach_title = /** @type {((inputs?: Camera_Attach_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_Attach_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_camera_attach_title(inputs)
});